<template>
  <div class="duration-picker">
    TODO
  </div>
</template>

<script>
export default {
  data: () => ({

  }),
  computed: {
  },
  methods: {
  }
}
</script>

<style>
</style>
